import { Tabs } from 'antd';
import { styled } from 'styled-components';

import { mq } from '@/shared/ui/styled';

export const StyledTabs = styled(Tabs)`
    width: 100%;

    .ant-tabs-tab {
        line-height: 130%;
        ${mq.md} {
            font-size: ${({ theme }) => theme.fontSize.md};
            line-height: 120%;
        }

        &:hover {
            color: ${({ theme }) => theme.color.dark};
            opacity: 0.8;
        }
    }

    .ant-tabs-tab-active > .ant-tabs-tab-btn {
        color: ${({ theme }) => theme.color.dark};
    }

    .ant-tabs-tab-btn {
        &:active {
            color: ${({ theme }) => theme.color.primary};
        }
    }

    .ant-tabs-ink-bar {
        background: ${({ theme }) => theme.color.primary};
    }
`;
